<template>
  <div>
    <el-button type="primary" @click="handleCancel">返回</el-button>
    <el-form ref="miniProgramForm" label-width="120px" :model="form" :rules="rules" style="padding: 30px;">
      <el-form-item label="地域选择：" prop="SourceType">
        <el-radio-group v-model="form.SourceType" @input="checkSource" size="medium">
          <el-radio v-for="{ label, value } in regionOptions" :label="value">{{ label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="form.SourceType == 1" label="选择省份：" prop="RegionName">
        <el-input v-model="form.RegionName" placeholder="请选择省份" id="citySelect_RegionName" />
      </el-form-item>
      <el-form-item v-show="form.SourceType == 2" label="选择城市：" prop="RegionName">
        <el-input v-model="form.RegionName" placeholder="请选择城市" id="citySelect2_RegionName" />
      </el-form-item>
      <el-form-item label="小程序名称" prop="AppName">
        <el-input v-model="form.AppName" placeholder="请输入小程序名称" />
      </el-form-item>
      <el-form-item label="小程序AppId" prop="AppId">
        <el-input v-model="form.AppId" placeholder="请输入小程序AppId" />
      </el-form-item>
      <el-form-item label="原始 ID" prop="OriginalId">
        <el-input v-model="form.OriginalId" placeholder="请输入原始 ID" />
      </el-form-item>
      <el-form-item label="小程序路径" prop="AppPath">
        <el-input v-model="form.AppPath" placeholder="请输入小程序路径" />
      </el-form-item>
      <el-form-item label="排序" prop="SortOrder">
        <el-input v-model="form.SortOrder" placeholder="请输入排序" />
      </el-form-item>
      <el-form-item label="封面Logo" prop="AppLogo" style="width:48%">
        <el-input v-model="form.AppLogo" :disabled="true" placeholder="请上传封面Logo" />
        <el-upload class="avatar-uploader" style="line-height: normal;" 
          :action="uploadUrl" 
          :headers="headers" 
          :show-file-list="false" :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload" :on-error="handleAvatarError">
          <img v-if="form.AppLogo" :src="form.AppLogo" class="avatar"
            style=" width:100px;height: auto;" />

          <div style="color: black !important;margin-top: 10px;">
            <el-button style="float: left;" type="primary" size="mini">本地上传</el-button>
            <el-button style="float: right;" type="primary" size="mini" @click.stop="addImgOnline">在线上传</el-button>
          </div>
          <div slot="tip" class="el-upload__tip">只能上传JPEG、JPG、PNG文件，且不超过5M</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">立即提交</el-button>
        <el-button type="primary" @click="handleCancel">取消</el-button>
      </el-form-item>


    </el-form>
    <el-dialog :modal="false" title="选择在线图片" :visible.sync="showDialog" width="70%">
      <el-select filterable v-model="FileGroupId" placeholder="请选择分组" style="margin:20px 0 0;" @change="checkGroup">
        <el-option v-for="(item, index) in imageGroupData" :key="index" :label="item.GroupName" :value="item.Id">
        </el-option>
      </el-select>
      <el-tabs v-model="FileGroupId" type="card" @tab-click="checkGroup" style="margin-top:20px">
        <el-tab-pane v-for="item in imageGroupData" :label="item.GroupName" :name="item.Id">
        </el-tab-pane>
      </el-tabs>
      <div style="color: red;margin-bottom: 12px;">提示：点击下方图片进行选择</div>
      <div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-wrap: wrap;">
        <div class="block" v-for="item in ImageListData" :key="item.FileId"
          style="position: relative;margin-right:20px">
          <el-image style="width: 100px; height: 100px;" :src="item.RemoteUrl" fit="fill"
            @click="getImgOnline(item.RemoteUrl)">
          </el-image>
        </div>
      </div>
      <!-- 分页组件 -->
      <el-row type="flex" justify="center" align="middle" style="height: 60px">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
          :page-size="page.pageSize" :page-sizes="[5, 10, 20, 30]" :current-page="page.pageIndex"
          @current-change="handleCurrentChange" @size-change="handleSizeChange">
        </el-pagination>
      </el-row>
    </el-dialog>
  </div>

</template>''

<script>
import { MyVcity, MyVcity_Provence } from '@/utils/chooseAllCity'
import { Loading } from 'element-ui';

export default {
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    formData: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      showDialog: false,
      imageGroupData: [],  //图库分组数据
      FileGroupId: '',
      ImageListData: [],  //图库下的图片
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      uploadUrl: this.$api.UploadFileListV2 + "?module=governmentapp",
      headers: {
        Authorization: `Bearer ${this.getCookie("tokenAdmin")}`,
      },
      total: 0,
      form: {
        SourceType: 0,
        RegionName: "全国",
        AppName: '',
        AppId: '',
        OriginalId:'',
        AppPath: '',
        SortOrder:"",
        AppLogo:""
      },
      regionOptions: [
        { value: 0, label: '全国' },
        { value: 1, label: '省份' },
        { value: 2, label: '城市' }
      ],


      rules: {
        SourceType: [{ required: true, message: '请选择地区', trigger: 'blur' }],
        RegionName: [{
          required: true, message: '请选择地区', trigger: 'blur',
          validator: (rule, value, callback) => {
            if (this.form.SourceType !== 0) {
              if (value) {
                callback();
              }
              else {
                callback(new Error("请选择省份/城市"));
              }
            } else {
              callback();
            }
          },
        }],
        AppName: [
            { required: true, message: '请输入小程序名称', trigger: 'blur' },
            { pattern: /^.{1,15}$/, message: '请输入1-15个字符' }
        ],
        AppId: [{ required: true, message: '请输入AppId', trigger: 'blur' }],
        OriginalId: [{ required: true, message: '请输入原始 ID', trigger: 'blur' }],
        // AppPath: [{ required: true, message: '请输入小程序路径', trigger: 'blur' }],
        SortOrder: [
            { required: true, message: '请输入排序', trigger: 'blur' }, 
            { pattern: /^\d{1,9}$/, message: '请输入正整数最多九位数字' }],
        AppLogo: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                callback();
              } else {
                callback(new Error("请上传封面Logo"));
              }
            },
            trigger: "blur",
            required: true,
          },
        ],

      },
    }
  },
  async created() {
    if (this.isEdit) {
      Object.assign(this.form, this.formData)
    }

  },
  mounted() {
    new MyVcity.CitySelector({ input: 'citySelect2_RegionName' });
    new MyVcity_Provence.CitySelector({ input: 'citySelect_RegionName' });
  },
  methods: {
    //#region 从图库获取图片
    addImgOnline() {
      this.showDialog = true
      this.getGroupFn()
    },
    //获取图库列表
    async getGroupFn() {
      this.$get(this.$api.GetFileGroup, {
        businessType: "ArticleImage",
      }).then((res) => {
        this.imageGroupData = res.Data;
        this.FileGroupId = res.Data[0]?.Id;
        this.getPageList();
      });
    },
    // 查询
    getPageList() {
      this.$get(this.$api.GetFilesFromGroup, {
        PageIndex: this.page.pageIndex, PageSize: this.page.pageSize, FileGroupId: this.FileGroupId 
      }).then((res) => {
       if (res.IsSuccess) {
          let arr = [];
          res.Data.forEach(item => {
            arr.push({
              checked: false,
              RemoteUrl: item.RemoteUrl,
              FileId: item.FileId
            })
          })
          this.ImageListData = arr
          this.total = res.TotalNumber
          // console.log(this.ImageListData)
        }
      }).catch(err => {
        console.log(err)
      });
    },
    checkGroup(tab, event) {
      this.page.pageIndex = 1
      this.getPageList()
    },
    getImgOnline(url) {
      this.form.AppLogo = url
      this.showDialog = false
    },
    // 查询
    /**
     * 检查数据源
     *
     * @description 将表单中城市名和省份名置空
     */
    checkSource(value) {
      value === 0 ? this.form.RegionName = '全国' : this.form.RegionName = ""
    },

    getCookie(name) {
      var matches = document.cookie.match(
        new RegExp("(?:^|; )" + name + "=([^;]*)")
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    beforeAvatarUpload(file) {
      this.loadingInstance = Loading.service();
      const isUpload = this.avatarLimit(file,'gif');
      if (!isUpload) {
        this.loadingInstance.close();
      }
      return isUpload;
    },
    avatarLimit(file,rule='') {
      const arr = file.name.split('.')
      const curType = arr[arr.length - 1].toLowerCase()
      console.log("curType", curType)
      let types = ['jpg', 'jpeg', 'png', 'gif'];
      const isJPG = types.includes(curType)
      console.log(isJPG, 'isJPG');
      const isLt5M = file.size / 1024 / 1024 < 5;
      if(curType===rule){
        Message.error('不能上传'+rule+'的图片');
        return false;
      }
      if (!isJPG) {
        Message.error('只能上传jpg、jpeg、png、gif格式的图片');
      }
      if (!isLt5M) {
        Message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    handleAvatarSuccess(res, file) {
      this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        this.loadingInstance.close();
      });
      this.form.AppLogo = (res.data && res.data.length > 0) ? res.data[0] : "";
      this.$refs.miniProgramForm.validateField("AppLogo", (errorMsg) => {
        if (errorMsg) {
        }
      });
    },
    handleAvatarError(err) {
      this.loadingInstance.close();
      console.log(err);
    },
    handleSubmit() {
      this.$refs.miniProgramForm.validate(async valid => {
        try {
          if (!valid) return;

          const actionType = this.isEdit ? '编辑' : '新增';
          const handleResponse = (res) => {
            if (res.IsSuccess) {
              this.$message.success(`${res.Message || actionType + '成功！'}`);
              this.$emit('success');
            } else {
              this.$message.error(`${res.Message || actionType + '失败！'}`);
            }
          };
          const {Id,SourceType,RegionName,AppName,AppId,SortOrder,AppLogo,AppPath,OriginalId} = this.form
          const formData = {
            SourceType,
            RegionName,
            AppName,
            AppId,
            OriginalId,
            SortOrder,
            AppLogo,
            AppPath
          }
          this.isEdit ? formData.Id = Id :""
          let res = await this.$post(this.$api.AddOrEditGovApp, formData);
          handleResponse(res)

        }
        catch (e) {
          // this.$message.error(`提交表单时发生错误：${e.message}`);
        }
      })
    },

    handleCancel() {
      this.$emit('close')
    },
    clearForm() {
      this.$refs.miniProgramForm.resetFields()
    },
    //#endregion
    //#region 分页
    handleCurrentChange(pageIndex) {
      this.page.pageIndex = pageIndex;
      this.getPageList(this.NewSearchData, false);
    },
    /**
     *
     * @param {*} pageSize
     */
    handleSizeChange(pageSize) {
      this.page.pageIndex = 1;
      this.page.pageSize = pageSize;
      this.getPageList(this.NewSearchData, false);
    }
  }
}
</script>
